import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询发票池
export function queryInvoicePool(data) {
  return request({
    url: URL.act.invoicePool.queryInvoicePool,
    method: 'post',
    data
  })
}

// 删除发票池
export function deleteInvoicePool(data) {
  return request({
    url: URL.act.invoicePool.deleteInvoicePool,
    method: 'delete',
    data
  })
}

// 拉取发票池
export function callInvoicePoolJob(params) {
  return request({
    url: URL.act.invoicePool.callInvoicePoolJob,
    method: 'get',
    params
  })
}
